import FieldsBooking from "graphql/fields/FieldsBooking";
import FieldsBuilding from "graphql/fields/FieldsBuilding";
import FieldsFloor from "graphql/fields/FieldsFloor";
import FieldsRoom from "graphql/fields/FieldsRoom";
import FieldsTable from "graphql/fields/FieldsTable";
import FieldsTimeslot from "graphql/fields/FieldsTimeslot";
import FieldsBookingInvitation from "graphql/fields/FieldsBookingInvitation";
import FieldsTranslation from 'graphql/fields/FieldsTranslation'

export default `
	${FieldsBooking}
	
	building {
		${FieldsBuilding}
	}
	
	employee {
		guid
		name
		photo_url
	}
	
	floor {
		${FieldsFloor}
	}
	
	room {
		${FieldsRoom}
	}
	
	table {
		${FieldsTable}
	}
	
	timeslot {
		${FieldsTimeslot}
		
		timeslot_kind {
			guid
			name
			kind
			sub_kind
	
			translations {
				${FieldsTranslation}
			}
		}
	}
	
	building_parking_space {
		guid
	}
	
	lunch_options {
		lunch_option {
			guid
		}
	}
	
	employee_scan {
		guid
		code
		scanned_in_at
		scanned_in_through
		status
	}
	
	booking_invitation {
		${FieldsBookingInvitation}
		
		employee {
			guid
			name
		}
		
		employees_invited {
			employee {
				guid
				name
			}
		}
	}
`;
